import { MembershipDependent } from "@/services/core-api-adapter";
import { ChevronDownIcon } from "@/theme/icons";
import { Stack, Typography, Select, MenuItem } from "@mui/material";
import { useState } from "react";

interface DependantsDropdownProps {
  selectMemberLabel: string;
  selectMemberPlaceholder: string;
  dependants: MembershipDependent[];
  setSelectedMembershipId: (id: any) => void;
}

export default function DependantsDropdown({
  selectMemberLabel,
  selectMemberPlaceholder,
  dependants,
  setSelectedMembershipId,
}: DependantsDropdownProps) {
  const [selectedMemberMembershipID, setSelectedMemberMembershipID] =
    useState<string>("");

  function handleSetSelectedMemberMembershipID(id: any) {
    setSelectedMembershipId(id);
  }

  return (
    <Stack spacing={2}>
      {selectMemberLabel && (
        <Typography align="left" variant="h3">
          {selectMemberLabel}
        </Typography>
      )}
      <Select
        fullWidth
        value={selectedMemberMembershipID}
        displayEmpty
        IconComponent={ChevronDownIcon}
        inputProps={{
          "aria-label": selectMemberPlaceholder,
        }}
        MenuProps={{
          "aria-label": selectMemberPlaceholder,
        }}
        sx={{
          backgroundColor: "background.paper",
        }}
        onChange={(event: any) => {
          setSelectedMemberMembershipID(event.target.value);
          handleSetSelectedMemberMembershipID(event.target.value);
        }}
        renderValue={
          selectedMemberMembershipID
            ? undefined
            : () => (
                <Typography
                  sx={{
                    color: (theme) => theme.palette.neutral[700],
                    textAlign: "left",
                  }}
                >
                  {selectMemberPlaceholder}
                </Typography>
              )
        }
      >
        {dependants.map((member: MembershipDependent, index: number) => {
          const label = member.firstName + " " + member.lastName;
          const value = member.memberId;
          const key = `${label}_${index}`;

          return (
            <MenuItem aria-label={`${label}`} key={key} value={value}>
              <Stack textAlign={"left"}>{label}</Stack>
            </MenuItem>
          );
        })}
      </Select>
    </Stack>
  );
}
